<template>
  <div class="voyage-info-panel">
    <div v-if="loading" class="loading-state">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="loading-text text-secondary">Loading voyage details...</p>
    </div>

    <div v-else-if="!voyage" class="not-found-state">
      <p class="text-secondary">Voyage not found.</p>
    </div>

    <dl v-else class="voyage-info-list">
      <dt>Voyage No.</dt>
      <dd>{{ voyage.mvygNumber || 'N/A' }}</dd>
      <dt>Asset</dt>
      <dd>{{ getAssetName() }}</dd>
      <dt>Period</dt>
      <dd>
        {{ voyage.mvygStartTime ? formatIndonesianDate(voyage.mvygStartTime) : 'N/A' }}
        <i class="ri-arrow-right-line text-secondary"></i>
        {{ voyage.mvygEndTime ? formatIndonesianDate(voyage.mvygEndTime) : 'N/A' }}
      </dd>
      <dt>Route</dt>
      <dd>
        {{ getOriginDisplayName() }}
        <i class="ri-arrow-right-line text-secondary"></i>
        {{ getDestinationDisplayName() }}
      </dd>
      <dt>Cargo</dt>
      <dd>
        {{ voyage.mvygCargoStatus ? 'With Cargo' : 'No Cargo' }}
        <template v-if="voyage.mvygCargoStatus">
          · {{ voyage.mvygCargoLoadKg || '0' }} kg · {{ voyage.mvygCargoType || 'N/A' }}
        </template>
      </dd>
      <dt>Note</dt>
      <dd>{{ voyage.mvygNote || 'N/A' }}</dd>
    </dl>
  </div>
</template>

<script>
import { useVoyageFormatters } from '@/views/voyage/composables/useVoyageFormatters';

export default {
  name: 'VoyageInfoPanel',
  props: {
    voyage: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const {
      formatIndonesianDate,
    } = useVoyageFormatters();

    return {
      formatIndonesianDate,
    };
  },
  methods: {
    getAssetName() {
      return this.voyage?.mvygMass?.massName || 'N/A';
    },
    getOriginDisplayName() {
      return this.voyage?.mvygOriginLndm?.lndmName || 'N/A';
    },
    getDestinationDisplayName() {
      return this.voyage?.mvygDestinationLndm?.lndmName || 'N/A';
    },
  },
};
</script>

<style scoped>
.voyage-info-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 12px;
}

.loading-state {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 160px;
  gap: 1rem;
}

.not-found-state {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 160px;
}

.voyage-info-list {
  display: grid;
  grid-template-columns: 100px minmax(0, 1fr);
  gap: 2px 10px;
  margin: 0;
  font-size: 14px;
}

.voyage-info-list dt {
  font-weight: 700;
  color: #455a64;
}

.voyage-info-list dd {
  margin: 0;
  color: #212529;
  overflow-wrap: anywhere;
}

@media (max-width: 767.98px) {
  .voyage-info-list {
    grid-template-columns: 88px minmax(0, 1fr);
  }
}
</style>
